import Vue from 'vue'
// import { findIndex } from 'lodash'
// import moment from 'moment'

const def = {1: 0, 2: 0, 3: 0, 4: 0, 5: 0}

export default {

  set_cookie (state, status) {
    if (status == '') { localStorage.removeItem('hit_cookie_settings') }

    state.cookie = status
  },
  set_loading (state, status) {
    state.loading = status
  },
  remove_page_color (state, color) {
    Object.keys(state.page.colors).forEach(function (key) {
      state.page.colors[key] = false
    })
  },
  set_page_color (state, color) {
    state.page.colors = Object.assign(state.page.colors, color)
  },

  set_unread_chat_messages (state, msg) {
    state.unread_chats = msg
  },

  change_mode (state, mode) {
    state.mode = mode
  },

  set_change_target_page (state, page) {
    if (typeof state.target_pages[ page.board ] === 'undefined') { state.target_pages[ page.board ] = { } }

    state.target_pages[ page.board ][ page.stars ] = page.text
  },

  set_target_pages (state, page) {
    state.target_pages = page
  },
  set_new_board (state, board) {
    if (state.boards.length) { state.boards.splice(0, 0, board.data) } else {
      state.boards = []
      state.boards.push(board.data)
    }

    if (typeof board.callback === 'function') { board.callback() }
  },

  set_change_user (state, user) {
    state.user[Object.keys(user)[0]] = Object.values(user)[0]

    var send = {
      user: state.user.md5_id,
      data: {}
    }

    send.data[Object.keys(user)[0]] = state.user[Object.keys(user)[0]]

    new Vue().$hit_post({url: 'user/update/',
      data: send,
      callback: function (ret) {
        console.log(ret)
      }})

    sessionStorage.setItem('user', btoa(JSON.stringify(state.user)))
  },

  get_session_user (state) {
    if (typeof sessionStorage.getItem('user') !== 'string') { return false }

    state.user = JSON.parse(atob(sessionStorage.getItem('user')))
  },

  clone_board (state, index) {
    var clone = JSON.parse(JSON.stringify(state.boards[index]))
    clone.ID = new Date().getTime()

    state.boards.splice(index, 0, clone)
  },

  set_remove_board (state, board) {
    state.boards.splice(board, 1)
  },

  set_feedback (state, feedback) {
    if (typeof state.feedback[feedback.board] === 'undefined') { state.feedback[feedback.board] = {} }

    state.feedback[feedback.board] = feedback.data
  },

  set_boards (state, boards) {
    state.boards = boards

    var avg = {}

    boards.forEach(function (vote) {
      avg[ (vote.ID * 1) ] = JSON.parse(JSON.stringify(def))
    })

    state.board_avg = avg
  },

  set_votes (state, votes) {
    state.votes = votes

    var avg = {}

    if (!state.boards) { return false }

    state.boards.forEach(function (vote) {
      avg[ (vote.ID * 1) ] = JSON.parse(JSON.stringify(def))
    })

    votes.forEach(function (vote) {
      avg[ (vote.board * 1) ][ Math.round(vote.average * 1) ] += 1
    })

    state.board_avg = avg
  },

  set_lang (state, language) {
    state.language = language
  },

  set_user (state, user) {
    state.user = user

    if (!user) { sessionStorage.removeItem('user') } else { sessionStorage.setItem('user', btoa(JSON.stringify(user))) }
  },

  set_change_board: function (state, data) {
    state.boards[data.index] = Object.assign(state.boards[data.index], data.data)
  },

  update_page_title: function (state, data) {
    state.page_title = data
  },

  set_admin_comment: function (state, data){

    state.votes.forEach(function(vote, index){

      if(vote.ID.toString() == data.ID.toString() && vote.board.toString() == data.board.toString()){
        state.votes[index].adminComment = data.data;
        return false;
      }

    });

  }

}
